<template>
  <div>
    <data-table
      title="Business Relations"
      ref="table"
      :items="businessRelations"
      :url="url"
      :headers="headers"
      :archive="false"
      :key="tableKey"
      @update-archived="(status) => (showArchived = status)"
    >
      <template v-slot:action.icons>
        <v-btn color="primary" @click="toggleForm">
          Add Business Relation
          <v-icon class="ml-2" color="light-blue lighten-4">
            mdi-comment-plus
          </v-icon>
        </v-btn>
      </template>
      <template v-slot:item.author="{ item }">
        {{ item.author.first_name }} {{ item.author.last_name }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn icon @click="editBusinessRelation(item)">
          <v-icon color="primary">mdi-pencil</v-icon>
        </v-btn>
        <v-btn icon @click="deleteBusinessRelation(item.id)">
          <v-icon color="primary">mdi-delete</v-icon>
        </v-btn>
      </template>
    </data-table>

    <!-- Optionally include the form for adding/updating business relations -->
    <v-dialog v-model="formVisible" @click:outside="closeDialog" width="600px">
      <v-card>
        <v-card-title class="primary white--text d-flex justify-space-between">
          <span>Add Business Relation</span>
          <v-btn text icon dark @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-container>
          <v-form ref="form" @submit.prevent="submitForm">
            <v-row no-gutters>
              <v-col cols="12" class="px-1">
                <v-textarea v-model="businessRelationForm.comment" label="Comment" required />
              </v-col>
              <v-col cols="12" class="px-1">
                <div class="flex-grow-1"></div>
                <v-btn color="primary" type="submit" rounded>
                  {{ editMode ? "Update" : "Add" }} Business Relation
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import instance from "@/services/http";
export default {
  props: { userId: { type: String } },
  data() {
    return {
      businessRelations: [],
      businessRelationForm: {
        id: null,
        owner: "",
        author: "",
        text: "",
      },
      editMode: false,
      formVisible: false,
      url: `/api/v1/business-relations/${this.userId}/comments`,
      headers: [
        { text: "Created at", value: "created_at" },
        { text: "Author", value: "author" },
        { text: "Comment", value: "comment" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      tableKey: 0,
    };
  },
  created() {},
  methods: {
    fetchBusinessRelations() {
      instance
        .get(this.url)
        .then((response) => {
          this.businessRelations = [...response.data];
        })
        .catch((error) => {
          console.error("Error fetching business relations:", error);
        });
    },

    createBusinessRelation() {
      instance
        .post(this.url, this.businessRelationForm)
        .then(() => {
          this.tableKey++;
          this.resetForm();
        })
        .catch((error) => {
          console.error("Error creating business relation:", error);
        });
    },

    updateBusinessRelation() {
      instance
        .put(`${this.url}/${this.businessRelationForm.id}`, this.businessRelationForm)
        .then(() => {
          this.tableKey++;
          this.resetForm();
        })
        .catch((error) => {
          console.error("Error updating business relation:", error);
        });
    },

    submitForm() {
      if (this.editMode) {
        this.updateBusinessRelation();
      } else {
        this.createBusinessRelation();
      }
    },

    editBusinessRelation(relation) {
      this.businessRelationForm = { ...relation };
      this.editMode = true;
      this.formVisible = true;
    },

    deleteBusinessRelation(id) {
      if (confirm("Are you sure you want to delete this business relation?")) {
        instance
          .delete(`${this.url}/${id}`)
          .then(() => {
            this.tableKey++;
          })
          .catch((error) => {
            console.error("Error deleting business relation:", error);
          });
      }
    },

    resetForm() {
      this.businessRelationForm = {
        id: null,
        owner: "",
        author: "",
        text: "",
      };
      this.editMode = false;
      this.formVisible = false;
    },

    toggleForm() {
      this.formVisible = !this.formVisible;
      if (!this.formVisible) {
        this.resetForm();
      }
    },

    showDetails(item) {
      console.log(item);
    },

    closeDialog() {
      this.formVisible = false;
    },
  },
};
</script>

<style scoped>
.business-relation-card {
  margin: 20px 0;
}
</style>
